import { apiFetch } from "@/lib/api";

export interface ApPurchaseOrderListRow {
  id: string;
  display_number: string | null;
  mv_number: string | null;
  mv_status: string | null;
  supplier_name: string | null;
  supplier_id?: string | null;
}

export async function fetchApPurchaseOrders(
  search: string | null,
  supplierId?: string | null,
  options?: { anySupplier?: boolean },
): Promise<ApPurchaseOrderListRow[]> {
  const params = new URLSearchParams();
  if (typeof search === "string" && search.trim() !== "") {
    params.set("q", search.trim());
  }
  if (options?.anySupplier === true) {
    params.set("scope", "any");
  } else if (typeof supplierId === "string" && supplierId.trim() !== "") {
    params.set("supplier_id", supplierId.trim());
  }
  const query = params.toString();
  const data = await apiFetch<{ rows: ApPurchaseOrderListRow[] }>(
    `/api/accounting/ap/purchase-orders${query !== "" ? `?${query}` : ""}`,
  );
  return data.rows;
}
